import { render, staticRenderFns } from "./Cake.vue?vue&type=template&id=3d5f504f&scoped=true&"
import script from "./Cake.vue?vue&type=script&lang=js&"
export * from "./Cake.vue?vue&type=script&lang=js&"
import style0 from "./Cake.vue?vue&type=style&index=0&id=3d5f504f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f504f",
  null
  
)

export default component.exports